import React from "react";

interface CurrentStore {
  stopIdleChecker: () => void;
  runIdleChecker: (loggedUser?: boolean) => void;
}

export const IdleCheckerContext = React.createContext<CurrentStore>({
  stopIdleChecker: () => {},
  runIdleChecker: () => {},
});
